angular.module('vm', [
    'pascalprecht.translate',
]);

angular.module('vm.helpCenter', [
    'vm',
    'vm.config',
    'vm.common',
    'pascalprecht.translate',
    'ngSanitize',
    'vcRecaptcha',
    'mgcrea.ngStrap',
])

    .config(function ($translateProvider) {
        $translateProvider.preferredLanguage('en');
    })

    .run(($injector) => {
        window.injector = $injector;
    })
;